
<mat-card class="overflow" >
    <mat-card-header class="titreFrm">
    <mat-card-title>CR&Eacute;ATION D'&Eacute;VALUATON</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
  <!-------------------- bouton -->
        <div class="btn">
            <div class="button-row">
              <button [disabled]="buttonDisabled"  (click)="enregister()" mat-raised-button class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
            </div>
        </div>
        <mat-tab-group #tabGroupe >
            <!-------------------- Création d’évaluation ------------>
            <mat-tab label="Création d’évaluation">
                <mat-card>
                    <mat-card-content>
                        <div class="displayFlex" >
                            <div class="display-inligne margin-right-50">
                                <mat-form-field     appearance="outline"  >
                                    <mat-label>Groupe</mat-label>
                                    <mat-select name="evaluation_Groupe" #evaluation_Groupe="ngModel" 
                                        [(ngModel)]="noteEvaluation.evaluation_Groupe" placeholder="Groupe" required>
                                        <mat-option *ngFor="let Groupe of listeGroupe" [value]="Groupe.value">
                                            {{Groupe.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field     appearance="outline"  class="width-100">
                                    <mat-label>Année scolaire</mat-label>
                                    <input matInput name="evaluation_anneeScolaire" #evaluation_anneeScolaire="ngModel" [(ngModel)]="noteEvaluation.evaluation_anneeScolaire"  placeholder="Année scolaire" required>
                                </mat-form-field>
                                <mat-form-field     appearance="outline"  class="width-120">
                                    <mat-label>Période</mat-label>
                                    <mat-select name="evaluation_periode" #evaluation_periode="ngModel" 
                                        [(ngModel)]="noteEvaluation.evaluation_periode" placeholder="Période" required>
                                        <mat-option *ngFor="let periode of listePeriode" [value]="periode.value">
                                            {{periode.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field     appearance="outline"  class="width-100">
                                    <mat-label>Date début</mat-label>
                                    <input matInput name="evaluation_date"
                                        #evaluation_date="ngModel" [(ngModel)]="noteEvaluation.evaluation_date" [matDatepicker]="picker1"
                                        placeholder="Date début" required>
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field     appearance="outline" >
                                    <mat-label>Thème</mat-label>
                                    <input matInput name="evaluation_theme" #evaluation_theme="ngModel" [(ngModel)]="noteEvaluation.evaluation_theme"  placeholder="Thème" required>
                                </mat-form-field>
                            </div>
                            <div class="display-inligne">
                                <mat-form-field     appearance="outline" >
                                    <mat-label>Type évaluation</mat-label>
                                    <mat-select name="evaluation_type" #evaluation_type="ngModel" 
                                        [(ngModel)]="noteEvaluation.evaluation_type" placeholder="Type évaluation" required>
                                        <mat-option *ngFor="let type of listeType" [value]="type.value">
                                            {{type.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field     appearance="outline" >
                                    <mat-label>Matière</mat-label>
                                    <mat-select name="evaluation_matiere" #evaluation_matiere="ngModel" 
                                        [(ngModel)]="noteEvaluation.evaluation_matiere" placeholder="Matière" required>
                                        <mat-option *ngFor="let matiere of listematiere" [value]="matiere.value">
                                            {{matiere.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field     appearance="outline" >
                                    <mat-label>Formateur</mat-label>
                                    <mat-select name="evaluation_Formateur" #evaluation_Formateur="ngModel" 
                                        [(ngModel)]="noteEvaluation.evaluation_Formateur" placeholder="Formateur" required>
                                        <mat-option *ngFor="let formateur of listeFormateur" [value]="formateur.value">
                                            {{formateur.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field     appearance="outline"  class="width-100">
                                    <mat-label>Coefficient</mat-label>
                                    <input matInput name="evaluation_Coefficient" #evaluation_Coefficient="ngModel" [(ngModel)]="noteEvaluation.evaluation_Coefficient"  placeholder="Coefficient" required>
                                </mat-form-field>
                            </div>
                        </div> 
                    </mat-card-content>
                </mat-card>
                
            </mat-tab>
            <!-------------------- Saisie des notes ------------>
            <mat-tab label="Saisie des notes">
                <mat-card>
                    <mat-card-content>
                        <div class="displayFlex" >
                            <div class="display-inligne margin-right-50">
                                <mat-form-field     appearance="outline"  class="width-100">
                                    <mat-label>Date début</mat-label>
                                    <input matInput name="evaluation_date2"
                                        #evaluation_date2="ngModel" [(ngModel)]="noteEvaluation.evaluation_date" [matDatepicker]="picker2"
                                        placeholder="Date début" required>
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field     appearance="outline"  >
                                    <mat-label>Groupe</mat-label>
                                    <mat-select disabled="true" name="evaluation_Groupe2" [ngModel]="noteEvaluation.evaluation_Groupe" placeholder="Groupe">
                                        <mat-option *ngFor="let Groupe of listeGroupe" [value]="Groupe.value">
                                            {{Groupe.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field     appearance="outline" >
                                    <mat-label>Matière</mat-label>
                                    <mat-select disabled="true" name="evaluation_matiere2" [ngModel]="noteEvaluation.evaluation_matiere" placeholder="Matière">
                                        <mat-option *ngFor="let matiere of listematiere" [value]="matiere.value">
                                            {{matiere.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field     appearance="outline" >
                                    <mat-label>Formateur</mat-label>
                                    <mat-select disabled="true" name="evaluation_Formateur2" [ngModel]="noteEvaluation.evaluation_Formateur" placeholder="Formateur">
                                        <mat-option *ngFor="let formateur of listeFormateur" [value]="formateur.value">
                                            {{formateur.text}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="display-inligne">
                                <div>
                                    <mat-form-field     appearance="outline"  class="width-120 margin-right-10">
                                        <mat-label>Période</mat-label>
                                        <mat-select disabled="true" name="evaluation_periode2" [ngModel]="noteEvaluation.evaluation_periode" placeholder="Période">
                                            <mat-option *ngFor="let periode of listePeriode" [value]="periode.value">
                                                {{periode.text}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field     appearance="outline"  class="width-100">
                                        <mat-label>Année scolaire</mat-label>
                                        <input disabled="true" matInput name="evaluation_anneeScolaire2" [ngModel]="noteEvaluation.evaluation_anneeScolaire"  placeholder="Année scolaire">
                                    </mat-form-field>
                                </div>
                                <mat-form-field     appearance="outline"  class="width-100">
                                    <mat-label>Coefficient</mat-label>
                                    <input matInput name="evaluation_Coefficient2" #evaluation_Coefficient2="ngModel" [(ngModel)]="noteEvaluation.evaluation_Coefficient"  placeholder="Coefficient" required>
                                </mat-form-field>
                                <mat-form-field     appearance="outline" >
                                    <mat-label>Thème</mat-label>
                                    <input matInput name="evaluation_theme2" #evaluation_theme2="ngModel" [(ngModel)]="noteEvaluation.evaluation_theme"  placeholder="Thème" required>
                                </mat-form-field>
                            </div>
                        </div> 
                        <app-avt-listes #listeEvaluationComponen [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columnsEvaluation" [listBtn]="listBtnEvaluation"  (btnTable)="clickBtnHeat($event)"></app-avt-listes>
                    </mat-card-content>
                </mat-card>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>